export class CorreoEnvioFilter {
   public nombre: string = "";
   public activo: number;
   public tipoEnvioCorreo: string = "";
   public tipoPlantillaEnvioCorreo: string = "";
}
